import { render, staticRenderFns } from "./planExplanation.vue?vue&type=template&id=0d0bdbfc&scoped=true"
import script from "./planExplanation.vue?vue&type=script&lang=js"
export * from "./planExplanation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0bdbfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0bdbfc')) {
      api.createRecord('0d0bdbfc', component.options)
    } else {
      api.reload('0d0bdbfc', component.options)
    }
    module.hot.accept("./planExplanation.vue?vue&type=template&id=0d0bdbfc&scoped=true", function () {
      api.rerender('0d0bdbfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/components/planExplanation.vue"
export default component.exports